"use client"

import * as React from "react"

export interface GradientButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'find' | 'clear' | 'outline' | 'default' | 'variant'
}

const GradientButton = React.forwardRef<HTMLButtonElement, GradientButtonProps>(
  ({ className = '', variant = 'default', children, ...props }, ref) => {
    const baseClasses = "inline-flex items-center justify-center gap-2 rounded-lg px-5 py-2.5 text-sm font-semibold transition-all duration-200 disabled:pointer-events-none disabled:opacity-50"

    const variantClasses = {
      find: "gradient-button-find text-gray-900 shadow-md hover:shadow-lg",
      clear: "gradient-button-clear text-white shadow-md hover:shadow-lg",
      outline: "border-2 border-primary-600 text-primary-600 bg-transparent hover:bg-primary-50",
      default: "gradient-button text-white",
      variant: "gradient-button-variant text-white",
    }

    return (
      <button
        className={`${baseClasses} ${variantClasses[variant]} ${className}`}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    )
  }
)
GradientButton.displayName = "GradientButton"

export { GradientButton }
